<template>
    <div class="content">
        <div class="title row-center">
            <span>通讯状态</span>
            <div class="query-right">
                <div class="dataContainer">
                    <div class="title">在线总数: </div>
                    <div class="data">{{ onlineNum }}</div>
                </div>
                <div class="dataContainer">
                    <div class="title">离线总数: </div>
                    <div class="data">{{ deviceNum - onlineNum }}</div>
                </div>
            </div>
        </div>
        <div class="body" id="communicationstatus">
            <div class="query">
                <div class="query-left">
                    <el-select v-model="deviceName" placeholder="全部设备">
                        <el-option v-for="item in devices" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="positionName" placeholder="位置">
                        <el-option v-for="item in position" :key="item.areaId" :label="item.areaName" :value="item.areaId">
                        </el-option>
                    </el-select>
                    <el-select v-model="statusName" placeholder="全部状态">
                        <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <input type="text" placeholder="请输入设备名称" v-model="deviceFilterText">
                    <el-button type="primary" @click="checksearch=true">查询</el-button>
                </div>
            </div>

            <div class="table">
                <table v-if="tableData.length > 0" >
                    <tr>
                        <th width="25%">设备名称</th>
                        <th width="25%">设备类型</th>
                        <th width="25%">所在站点</th>
                        <th width="15%">通讯状态</th>
                    </tr>
                    <tr v-for="item in tableData">
                        <td>{{item.device_name}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.area_name}}</td>
                        <td><img :src="item.onlineImg ? item.onlineImg : require('@/assets/img/离线.png')"
                                alt="" style="width:32px; height:24px"></td>
                    </tr>
                </table>
                <div v-else class="row-center tip">
                    <img v-if="!loading" src="@/assets/img/not_found_data.png" alt="">
                    <img v-else src="@/assets/img/loading.png" alt="" class="loading">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        GetEboxAndMonitor,GET_AREAS
    } from "../../api/power"
    export default {
        name: "CommunicationStatus",
        components: {
        },
        data() {
            return {
                loading: false,
                deviceName: "全部设备",
                statusName: "全部状态",
                deviceFilterText: "",
                positionName:"",
                position:[],
                devices: [{
                    value: '全部设备',
                    label: '全部设备'
                }, {
                    value: '网关设备',
                    label: '网关设备'
                }, {
                    value: '安防设备',
                    label: '安防设备'
                }],
                status: [{
                    value: '全部状态',
                    label: '全部状态'
                }, {
                    value: '在线',
                    label: '在线'
                }, {
                    value: '离线',
                    label: '离线'
                }],
                deviceNum: 0,
                onlineNum: 0,
                eBoxInfos: [],
                allData: [],
                monitorStatus: [],
                checksearch:false,
                allDataCopy:[]
            }
        },
        created() {
            GET_AREAS().then(res => {
                let obj = [{
                    areaName:"所在站点",
                    areaId:""
                }]
                this.position = obj.concat(res.data.data.areas)
            })
            this.getEboxandMonitor()
        },
        computed: {
            tableData() {
                let allData = this.allDataCopy
                let onlineNum = 0
                allData.forEach((item, index) => {
                    if (item.device_category_id == 3) {
                        let currentEboxDetail = this.$store.getters.eBoxInfo().find(value =>
                            {
                                if(JSON.parse(item.device_details)['设备']){
                                    JSON.parse(item.device_details)['设备'].code == value.deviceId &&
                                    value.projectName == this.$store.state.project.projectInfo.influxDbName
                                }
                                return value
                            }
                        )
                        if (currentEboxDetail && currentEboxDetail.online == true) {
                            this.$set(allData[index], 'online', 'true')
                            this.$set(allData[index], 'onlineImg', require('@/assets/img/在线.png'))
                            onlineNum++
                        } else {
                            this.$set(allData[index], 'online', 'false')
                            this.$set(allData[index], 'onlineImg', require('@/assets/img/离线.png'))
                        }
                    } else if (item.device_category_id == 2) {
                        let currentMonitorDetail = this.$store.getters.eBoxInfo().find(value =>
                            JSON.parse(item.device_details)['cameraId'] == value.deviceId && value
                            .projectName == this.$store.state.project.projectInfo.influxDbName)
                        if (currentMonitorDetail && currentMonitorDetail.online) {
                            this.$set(allData[index], 'online', 'true')
                            this.$set(allData[index], 'onlineImg', require('@/assets/img/在线.png'))
                            onlineNum++
                        } else {
                            this.$set(allData[index], 'online', 'false')
                            this.$set(allData[index], 'onlineImg', require('@/assets/img/离线.png'))
                        }
                    }
                })
                // this.onlineNum = onlineNum
                return allData.filter(item => (item.device_name.includes(this.deviceFilterText)))
            },
        },
        watch:{
            checksearch(n,o){
                let name = this.deviceName == '全部设备' ? '' : this.deviceName
                let status = this.statusName == '全部状态' ? '' : this.statusName == '在线' ? 'true' : 'false'
                let positionName = this.positionName
                if(n){
                    let list = []
                    this.allData.forEach(item => {
                        if(item.device_name.includes(this.deviceFilterText) && item.name
                        .includes(name) && item.online.includes(status)){
                            if(positionName==""){
                                list.push(item)
                            }else{
                                if(item.area_id==positionName){
                                    list.push(item)
                                }
                            }
                        }
                    })
                    this.checksearch = false
                    this.allDataCopy = list
                }
            }

        },
        mounted() {
        },
        methods: {
            getEboxandMonitor() {
                // console.log(this.$store.getters.eBoxInfo(),"this.$store.getters.eBoxInfo()")
                GetEboxAndMonitor().then(res => {
                    this.allData = res.data.data.devices.filter(item => item.device_type_name != '门禁')
                    this.allDataCopy = this.allData
                    this.deviceNum = this.allData.length;
                    let onlineNum = 0
                    this.allData.forEach((item, index) => {
                        if (item.device_category_id == 3) {
                            let currentEboxDetail = this.$store.getters.eBoxInfo().find(value =>
                                {
                                    if(JSON.parse(item.device_details)['设备']){
                                        JSON.parse(item.device_details)['设备'].code == value.deviceId &&
                                        value.projectName == this.$store.state.project.projectInfo.influxDbName
                                    }
                                    return value
                                }
                                )
                            if (currentEboxDetail && currentEboxDetail.online == true) {
                                onlineNum++
                            } 
                        } else if (item.device_category_id == 2) {
                            let currentMonitorDetail = this.$store.getters.eBoxInfo().find(value =>
                                JSON.parse(item.device_details)['cameraId'] == value.deviceId && value
                                .projectName == this.$store.state.project.projectInfo.influxDbName)
                            if (currentMonitorDetail && currentMonitorDetail.online) {
                                onlineNum++
                            } 
                        }
                    })
                    this.onlineNum = onlineNum
                })
            },
        }
    };
</script>

<style lang="less" scoped>
    .content {
        width:100%;
        height:100%;
        background: #ffffff;
        padding: 20px;
        // display: flex;
        // flex-direction: column;
        // justify-content: space-between;
        // align-items: center;
        .title{
            font-size: 18rem;
            font-weight: bold;
            justify-content: space-between;
            .query-right {
                .w(300);
                // height: 40px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                .dataContainer {
                    // height: 40px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;

                    .title {
                        font-size: 18rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    .data {
                        font-size: 18rem;
                        font-weight: bold;
                        color: #0D94FF;
                        margin-left: 100/192vw;
                    }
                }
            }
        }
    }

    .body {
        width: 100%;
        .h(874);
        margin-top: 250/108vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .query {
            width: 100%;
            height: 40px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .query-left {
                .w(832);
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .el-select {
                    .w(260);
                    height: 40px;
                    margin-right: 80/192vw;
                }

                .el-input {
                    .w(280);
                    height: 40px;
                    border-radius: 4px;
                    // border: 1px solid rgba(0, 0, 0, 0.15);
                    // padding-left: 150/192vw;
                    margin-right: 160/192vw;
                }

                input {
                    .w(280);
                    height: 40px;
                    border-radius: 4px;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    padding-left: 150/192vw;
                    margin-right: 160/192vw;
                }

                .btn {
                    .w(96);
                    height: 40px;
                    border-radius: 4px;
                    background: rgba(13, 148, 255, 1);
                    font-size: 18rem;
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                }
            }

            
        }
        .table{
            position: relative;
            overflow: hidden;
            box-sizing: border-box;
            width: 100%;
            font-size: 20rem;
            .h(800);
            overflow-y: auto;
            table{
                width: 100%;
                border-collapse:collapse;
                th{
                    background: #f0f3f6;
                    font-size: 18rem;
                    height: 40rem;
                    text-align: left;
                    padding-left: 60rem;
                }
                td{
                    height: 70rem;   
                    padding-left: 60rem;
                }
                tr:nth-child(even){
                    background: rgba(0,0,0,0.02);
                    border: 1px solid rgba(0,0,0,0.04);
                }
            }
        }
    }

    .tip {
        width: 100%;
        height: 100%;
        font-size: 16rem;
        color: #8c939d;
    }

    .loading {
        width: 28rem;
        height: 28rem;
        animation: loading 1s linear infinite;
    }

    @keyframes loading {
        0% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>